export default __webpack_public_path__ + "static/media/0105.d55099c9.png";